var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exam_left" }, [
    _c(
      "div",
      { staticClass: "left_wrap" },
      [
        _vm.paperData !== null
          ? _c(
              "el-collapse",
              {
                staticStyle: {
                  "overflow-y": "auto",
                  "overflow-x": "hidden",
                  height: "100%"
                },
                model: {
                  value: _vm.activeNames,
                  callback: function($$v) {
                    _vm.activeNames = $$v
                  },
                  expression: "activeNames"
                }
              },
              [
                _vm._l(_vm.leftData, function(qitem, index) {
                  return _c(
                    "el-collapse-item",
                    {
                      key: index,
                      attrs: {
                        title:
                          (qitem.sectionAlias || qitem.sectionName) +
                          "   (共" +
                          (qitem.testPaperQuestionsList == null
                            ? ""
                            : qitem.testPaperQuestionsList.length) +
                          "题)",
                        name: index
                      }
                    },
                    [
                      _c(
                        "ul",
                        { staticClass: "topic_wrap" },
                        [
                          _vm._l(qitem.testPaperQuestionsList, function(
                            item,
                            index1
                          ) {
                            return qitem.orderSort === 0
                              ? _c(
                                  "li",
                                  {
                                    key: index1,
                                    staticClass: "topic_num",
                                    class: [
                                      { active: _vm.num === item.id },
                                      { select: item.selected },
                                      { makeAnswer: item.makeAnswer }
                                    ],
                                    attrs: { title: item.selected },
                                    on: {
                                      click: function($event) {
                                        return _vm.setQuestion(
                                          item,
                                          item.id,
                                          qitem.testPaperQuestionsList,
                                          index1,
                                          item.questionId
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(index1 + 1) + "\n          ")]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _vm._l(qitem.testPaperQuestionsList, function(
                            item,
                            index1
                          ) {
                            return qitem.orderSort === 1
                              ? _c(
                                  "li",
                                  {
                                    key: index1,
                                    staticClass: "topic_num",
                                    class: [
                                      { active: _vm.num === item.id },
                                      { select: item.selected },
                                      { makeAnswer: item.makeAnswer }
                                    ],
                                    attrs: { title: item.selected },
                                    on: {
                                      click: function($event) {
                                        return _vm.setQuestion(
                                          item,
                                          item.id,
                                          qitem.testPaperQuestionsList,
                                          index1,
                                          item.questionId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.leftData[0].testPaperQuestionsList
                                            .length +
                                            index1 +
                                            1
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _vm._l(qitem.testPaperQuestionsList, function(
                            item,
                            index1
                          ) {
                            return qitem.orderSort === 2
                              ? _c(
                                  "li",
                                  {
                                    key: index1,
                                    staticClass: "topic_num",
                                    class: [
                                      { active: _vm.num === item.id },
                                      { select: item.selected },
                                      { makeAnswer: item.makeAnswer }
                                    ],
                                    attrs: { title: item.selected },
                                    on: {
                                      click: function($event) {
                                        return _vm.setQuestion(
                                          item,
                                          item.id,
                                          qitem.testPaperQuestionsList,
                                          index1,
                                          item.questionId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.leftData[0].testPaperQuestionsList
                                            .length +
                                            _vm.leftData[1]
                                              .testPaperQuestionsList.length +
                                            index1 +
                                            1
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _vm._l(qitem.testPaperQuestionsList, function(
                            item,
                            index1
                          ) {
                            return qitem.orderSort === 3
                              ? _c(
                                  "li",
                                  {
                                    key: index1,
                                    staticClass: "topic_num",
                                    class: [
                                      { active: _vm.num === item.id },
                                      { select: item.selected },
                                      { makeAnswer: item.makeAnswer }
                                    ],
                                    attrs: { title: item.selected },
                                    on: {
                                      click: function($event) {
                                        return _vm.setQuestion(
                                          item,
                                          item.id,
                                          qitem.testPaperQuestionsList,
                                          index1,
                                          item.questionId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.leftData[0].testPaperQuestionsList
                                            .length +
                                            _vm.leftData[1]
                                              .testPaperQuestionsList.length +
                                            _vm.leftData[2]
                                              .testPaperQuestionsList.length +
                                            index1 +
                                            1
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _vm._l(qitem.testPaperQuestionsList, function(
                            item,
                            index1
                          ) {
                            return qitem.orderSort === 4
                              ? _c(
                                  "li",
                                  {
                                    key: index1,
                                    staticClass: "topic_num",
                                    class: [
                                      { active: _vm.num === item.id },
                                      { select: item.selected },
                                      { makeAnswer: item.makeAnswer }
                                    ],
                                    attrs: { title: item.selected },
                                    on: {
                                      click: function($event) {
                                        return _vm.setQuestion(
                                          item,
                                          item.id,
                                          qitem.testPaperQuestionsList,
                                          index1,
                                          item.questionId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.leftData[0].testPaperQuestionsList
                                            .length +
                                            _vm.leftData[1]
                                              .testPaperQuestionsList.length +
                                            _vm.leftData[2]
                                              .testPaperQuestionsList.length +
                                            _vm.leftData[3]
                                              .testPaperQuestionsList.length +
                                            index1 +
                                            1
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _vm._l(qitem.testPaperQuestionsList, function(
                            item,
                            index1
                          ) {
                            return qitem.orderSort === 5
                              ? _c(
                                  "li",
                                  {
                                    key: index1,
                                    staticClass: "topic_num",
                                    class: [
                                      { active: _vm.num === item.id },
                                      { select: item.selected },
                                      { makeAnswer: item.makeAnswer }
                                    ],
                                    attrs: { title: item.selected },
                                    on: {
                                      click: function($event) {
                                        return _vm.setQuestion(
                                          item,
                                          item.id,
                                          qitem.testPaperQuestionsList,
                                          index1,
                                          item.questionId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.leftData[0].testPaperQuestionsList
                                            .length +
                                            _vm.leftData[1]
                                              .testPaperQuestionsList.length +
                                            _vm.leftData[2]
                                              .testPaperQuestionsList.length +
                                            index1 +
                                            1
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _vm._l(qitem.testPaperQuestionsList, function(
                            item,
                            index1
                          ) {
                            return qitem.orderSort === 6
                              ? _c(
                                  "li",
                                  {
                                    key: index1,
                                    staticClass: "topic_num",
                                    class: [
                                      { active: _vm.num === item.id },
                                      { select: item.selected },
                                      { makeAnswer: item.makeAnswer }
                                    ],
                                    attrs: { title: item.selected },
                                    on: {
                                      click: function($event) {
                                        return _vm.setQuestion(
                                          item,
                                          item.id,
                                          qitem.testPaperQuestionsList,
                                          index1,
                                          item.questionId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.leftData[0].testPaperQuestionsList
                                            .length +
                                            _vm.leftData[1]
                                              .testPaperQuestionsList.length +
                                            _vm.leftData[2]
                                              .testPaperQuestionsList.length +
                                            index1 +
                                            1
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _vm._l(qitem.testPaperQuestionsList, function(
                            item,
                            index1
                          ) {
                            return qitem.orderSort === 7
                              ? _c(
                                  "li",
                                  {
                                    key: index1,
                                    staticClass: "topic_num",
                                    class: [
                                      { active: _vm.num === item.id },
                                      { select: item.selected },
                                      { makeAnswer: item.makeAnswer }
                                    ],
                                    attrs: { title: item.selected },
                                    on: {
                                      click: function($event) {
                                        return _vm.setQuestion(
                                          item,
                                          item.id,
                                          qitem.testPaperQuestionsList,
                                          index1,
                                          item.questionId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.leftData[0].testPaperQuestionsList
                                            .length +
                                            _vm.leftData[1]
                                              .testPaperQuestionsList.length +
                                            _vm.leftData[2]
                                              .testPaperQuestionsList.length +
                                            index1 +
                                            1
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "left_footer" }, [
                  _c("div", { staticClass: "not_do" }, [
                    _c("p"),
                    _vm._v(" "),
                    _c("p", [_vm._v("未做")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "do" }, [
                    _c("p"),
                    _vm._v(" "),
                    _c("p", [_vm._v("已做")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "current" }, [
                    _c("p"),
                    _vm._v(" "),
                    _c("p", [_vm._v("当前")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "select" }, [
                    _c("p"),
                    _vm._v(" "),
                    _c("p", [_vm._v("待定")])
                  ])
                ])
              ],
              2
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0cfd31a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0cfd31a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testComponent/examLeft.vue
// module id = null
// module chunks = 